import { LinkField } from '@sitecore-jss/sitecore-jss-react';

type HTMLAnchorOrLinkField = HTMLAnchorElement | LinkField;

const joinCodeExpression = /(\?|&(?:amp;)?|^)joinCode=([^&^#]*)(.*)/i;

/**
 * Checks a url to see if it is poiting at our join the registry site
 * As a join url can never be null or empty, this also tells us href
 * is non-null.
 * @param {string | undefined} href The url to check
 * @returns {boolean} true if @see href is a join the registry url.
 */
export const isJoinUrl = (href?: string): href is string => {
  const urls = [
    'https://my.bethematch.org/s/join',
    'https://my.nmdp.org/s/join',
    'https://my.nmdp.org/s/knowledge-check',
    'https://preprod-bethematch.cs77.force.com/mybtm/s',
    'https://nmdp--qagroot.sandbox.my.site.com/mynmdp/s/',
    'https://nmdp--devgroot.sandbox.my.site.com/mynmdp/s/',
    'https://nmdp--qae2e.sandbox.my.site.com/mynmdp/s/',
    'https://nmdp--preprod.sandbox.my.site.com/mynmdp/s/',
  ];
  // If href is null or empty return false right away
  if (!href?.length) {
    return false;
  }
  try {
    // lowercase href in case user LIKES TO TYPE IN CAPS
    const checkHost = new URL(href.toLowerCase()).hostname;

    // Extract just the hostnames from the urls array
    const allowedHosts = urls.map((url) => new URL(url).hostname.toLowerCase());
    return allowedHosts.includes(checkHost);
  } catch {
    return false;
  }
};

/**
 * Adds or replaces any join cyde presing in a
 */
const replaceQueryJoinCode = ({
  query,
  joinCode,
  separator,
}: {
  query?: string;
  joinCode: string;
  separator?: string;
}) => {
  // If the value we were passed is undefined or empty send it right back to the caller
  if (!query?.length) {
    return `joinCode=${joinCode}`;
  }
  // Do we have a join code in our input?
  if (joinCodeExpression.test(query)) {
    // yes - replace it.
    return query.replace(joinCodeExpression, `$1joinCode=${joinCode}$3`);
  }
  // Otherwise split by hash nav so we don't loose it
  const parts = query.split('#');
  // Figure out the correct parameter separator
  let cbSeparate = separator ?? parts[0].includes('?') ? '&' : '?';
  // handle empty queries which might or might not happen
  if (parts[0].endsWith('?')) {
    cbSeparate = '';
  }
  // Add in a join code
  const urlPart = `${parts[0]}${cbSeparate}joinCode=${joinCode}`;
  // And add the hash nav back if necessary
  return parts.length === 1 ? urlPart : `${urlPart}#${parts[1]}`;
};

export const handleJoinCode = ({
  a,
  joinCode,
}: {
  a: HTMLAnchorOrLinkField;
  joinCode: string | undefined;
}) => {
  // if joinCode is falsy there's nothing for us to do, early-exit
  if (!joinCode) {
    return;
  }
  // Set a local variable for a so SonarQube doesn't complain about updating it
  const myClonedLink = a;
  // Vercel's node build doesn't know about the HTMLAnchorClass, but if we have a setAttribute
  // method we have an anchor object, or something that should behave like it
  if ('setAttribute' in myClonedLink) {
    const isJoinLink = isJoinUrl(myClonedLink.href);
    if (isJoinLink) {
      myClonedLink.setAttribute(
        'href',
        replaceQueryJoinCode({ joinCode, query: myClonedLink.href }) ?? myClonedLink.href
      );
    }
  } else {
    // Otherwise we have a Link field
    const isJoinLink = isJoinUrl(myClonedLink.value?.href);
    if (isJoinLink) {
      if (myClonedLink.value.querystring) {
        myClonedLink.value.querystring = replaceQueryJoinCode({
          joinCode,
          query: myClonedLink.value.querystring,
          separator: '&',
        });
      } else {
        myClonedLink.value.href = replaceQueryJoinCode({
          joinCode,
          query: myClonedLink.value.href,
        });
      }
    }
  }
};
